module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/PlayBlack.66e50084.svg";